import * as React from 'react';
import { useSelector } from 'react-redux';

import { CalculateResultContainer } from './CalculateResultContainer';
import { selectCalculateResult } from '../../selectors/calculate';

export const CalculateResultConditionalContainer: React.FC = () => {
  const calculateResult = useSelector(selectCalculateResult);

  if (!calculateResult) {
    return null;
  }

  return <CalculateResultContainer calculateResult={calculateResult} />;
};
